import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { LoaderModule } from "src/app/shared/loader/loader.module";
import { SharedModule } from "src/app/shared/shared.module";
import { ClinicalComponent } from "./clinical.component";
import { ClinicalRoutingModule } from "./clinical-routing.module";
import { NgxBarCodePutDirective } from "src/app/shared/directives/NgxBarCodePutDirective";
import { AutofocusDirective } from "src/app/shared/directives/autofocus.directive";
import { PatientDetailComponent } from './patient-detail/patient-detail.component';

@NgModule({
  declarations: [
    ClinicalComponent,
    PatientDetailComponent,
    NgxBarCodePutDirective,
    AutofocusDirective
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule,
    LoaderModule,
    SharedModule,
    ClinicalRoutingModule
  ],
  exports: [
    NgxBarCodePutDirective,
    AutofocusDirective
  ]

})
export class ClinicalModule { }
